import { useContext, useEffect } from 'react'
import { Query } from './Query'
import { Api } from './Api'
import { Box, IconButton, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'

import WorkspacesIcon from '@mui/icons-material/Workspaces';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ApiIcon from '@mui/icons-material/Api';
import AddIcon from '@mui/icons-material/Add';
import { Context } from './Context';
import { gettingReportById } from 'utils/Reports';

const ApiUsed = ({ open, setOpen, selectedRow, rows }) => {
    const {
        categories,
        queries,
        apis,
        setQueries,
        setParams,
        setApis,
        setLoadingReport,
    } = useContext(Context)

    useEffect(() => {
        if (open) {
            gettingReportById(
                selectedRow[0],
                setLoadingReport,
                setQueries,
                setParams,
                setApis,
                categories
            )
        }

    }, [open])

    return (
        <>
            <List sx={{ border: theme => `1px solid ${theme.palette.divider}`, borderRadius: '5px' }}>
                {categories.map((category, index) => (
                    <>
                        <ListItem key={`item-${category.name}-${index}`}>
                            <ListItemIcon>
                                <WorkspacesIcon />
                            </ListItemIcon>

                            <ListItemText primary={category.name} />
                        </ListItem>

                        <ListItem
                            key={`query-${category.name}-${index}`}
                            sx={{ pl: 6 }}
                            secondaryAction={
                                <IconButton
                                    edge="end"
                                    aria-label="add-query"
                                    onClick={() => {
                                        setQueries([
                                            ...queries,
                                            {
                                                category: category.name,
                                                name: "",
                                                string: "",
                                                params: []
                                            }
                                        ])
                                    }}
                                >
                                    <AddIcon />
                                </IconButton>
                            }
                        >
                            <ListItemIcon>
                                <DataObjectIcon />
                            </ListItemIcon>

                            <ListItemText primary={'QUERIES'} />
                        </ListItem>

                        <Box
                            sx={{
                                pt: 2,
                                pl: 10,
                                pr: 10
                            }}
                        >

                            <Query
                                key={index}
                                category={category}
                            />
                        </Box>

                        <ListItem
                            key={`apis-${category.name}-${index}`}
                            sx={{ pl: 6 }}
                            secondaryAction={
                                <IconButton
                                    edge="end"
                                    aria-label="add-api"
                                    onClick={() => {
                                        const exist = apis.find(api => api.category === category.name && api.id === "")

                                        if (exist) { return }

                                        setApis([
                                            ...apis,
                                            {
                                                category: category.name,
                                                id: new Date().getTime().toString(),
                                                value: ""
                                            }
                                        ])
                                    }}
                                    disabled={apis.find(api => api.category === category.name && api.id === "")}
                                >
                                    <AddIcon />
                                </IconButton>
                            }
                        >
                            <ListItemIcon>
                                <ApiIcon />
                            </ListItemIcon>

                            <ListItemText primary={'APIS'} />
                        </ListItem>

                        <Box
                            sx={{
                                pl: 10,
                                pr: 10
                            }}
                        >

                            <Api
                                key={index}
                                category={category}
                            />
                        </Box>
                    </>
                ))}
            </List>
        </>
    )
}

export { ApiUsed }